import { ReactComponent as WorldMap } from 'assets/world.svg';
import { useEffect, useRef } from 'react';
import './World.scss';

interface IWorldProps {
  activeCountries: string[];
}

const World = ({ activeCountries }: IWorldProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    const paths = ref.current.querySelectorAll('path');

    // reset
    paths.forEach((p) => {
      p.classList.remove('active-country');
      p.style.fillOpacity = '1';
    });

    const total = activeCountries.length;

    activeCountries.forEach((country, index) => {
      const el = ref.current?.querySelector(`#${country}`) as SVGPathElement;

      if (!el) return;

      el.classList.add('active-country');

      // opacity jak w Twoim wzorze
      const opacity = (total - index) / total;

      el.style.fillOpacity = opacity.toString();
    });
  }, [activeCountries]);

  return (
    <div ref={ref} className="world-map">
      {/* <WorldMap /> */}
      <WorldMap />
    </div>
  );
};

export default World;
